export const STATIONS_REQUEST = "STATIONS_REQUEST";
export const STATIONS_SUCCESS = "STATIONS_SUCCESS";
export const STATIONS_ERROR = "STATIONS_ERROR";

export const STATIONS_2_REQUEST = "STATIONS_2_REQUEST";
export const STATIONS_2_SUCCESS = "STATIONS_2_SUCCESS";
export const STATIONS_2_ERROR = "STATIONS_2_ERROR";

export const STATIONSTATUS_REQUEST = "STATIONSTATUS_REQUEST";
export const STATIONSTATUS_SUCCESS = "STATIONSTATUS_SUCCESS";
export const STATIONSTATUS_ERROR = "STATIONSTATUS_ERROR";

export const FUELS_REQUEST = "FUELS_REQUEST";
export const FUELS_SUCCESS = "FUELS_SUCCESS";
export const FUELS_ERROR = "FUELS_ERROR";